import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import KStadiumAPI from '../../apis/kstadiumAPI';

const useRecaptcha = () => {
  const [isValid, setIsValid] = useState(false);
  const { mutate: confirmRecaptcha } = useMutation(
    KStadiumAPI.confirmRecaptcha,
    {
      onSuccess: ({ data: { success } }) => {
        setIsValid(success);
      },
      onError: (error) => {
        setIsValid(false);
      },
    },
  );

  const handleChange = (token: string | null) => {
    if (token) confirmRecaptcha({ recaptchaToken: token });

    setIsValid(!!token);
  };

  return {
    isValid,
    handleChange,
  };
};

export default useRecaptcha;
